<template>
  <v-container>
    <v-form>
      <v-layout justify-center>
        <v-container>
          <v-layout>
            <v-flex>
              <boton-captura></boton-captura>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex></v-flex>
          </v-layout>
          <v-layout> </v-layout>
        </v-container>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
import BotonCaptura from "@/modules/configuration/commonsviews/BotonesProcesoCaptura.vue";

export default {
  components: {
    BotonCaptura,
  },
  props: {},
  data() {
    return {};
  },
  computed: {},
  created() {
    this.$store.commit("tab_state", "Proceso");
    //this.$store.commit("sub_tab_state", "");
  },
  methods: {},
};
</script>
